document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-ca-book-hero]').forEach(root=>{
    const panels=[...root.querySelectorAll('[data-ca-panel]')];
    const galleryButtons=[...root.querySelectorAll('[data-ca-gallery-button]')];
    galleryButtons.forEach(button=>button.addEventListener('click',()=>{
      const index=button.dataset.caGalleryButton;
      panels.forEach(panel=>panel.hidden=panel.dataset.caPanel!==index);
      galleryButtons.forEach(item=>item.classList.toggle('is-active',item===button));
    }));
    root.querySelectorAll('[data-ca-video-play]').forEach(button=>button.addEventListener('click',()=>{
      const video=button.parentElement.querySelector('video');
      if(video){video.controls=true;video.play();button.hidden=true;}
    }));
    const hiddenVariant=root.querySelector('[data-ca-book-selected-variant]');
    const price=root.querySelector('[data-ca-book-price]');
    const cardPrice=root.querySelector('[data-ca-book-card-price]');
    const add=root.querySelector('[data-ca-book-add]');
    root.querySelectorAll('[data-ca-book-variant]').forEach(input=>input.addEventListener('change',()=>{
      root.querySelectorAll('.ca-demo-format-options label').forEach(label=>label.classList.toggle('is-selected',label.contains(input)));
      hiddenVariant.value=input.value;
      const displayPrice=input.dataset.price.replace(/<[^>]*>/g,'');
      price.textContent=displayPrice;
      if(cardPrice) cardPrice.textContent=displayPrice.replace(/\s+[A-Z]{3}$/,'');
      const available=input.dataset.available==='true';
      add.disabled=!available;
      add.textContent=available?add.dataset.addLabel:add.dataset.soldLabel;
    }));
  });
});
